import * as React from "react"
import { Box, Chip } from "@mui/material"

import {NotAllowedBlock} from "@components";


export default function restOfColumn() {
    return {
        name: 'numImages', label: 'Rest Of',
        options: {
            filter: false,
            setCellHeaderProps: () => ({ sx: { whiteSpace: 'nowrap' } }),
            customBodyRowRenderLite: (value) => {
                return <Box display="flex" justifyContent="center">
                    {value > 6 && <Chip label={`+${value - 6}`} sx={{ p: 1 }} color="primary" />}
                    {value <= 6 && <NotAllowedBlock />}
                </Box>
            }
        }
    }
}
